"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiRetailQueryTargetPassageType = exports.KpiRetailQueryTarget = exports.KpiRetailFilterType = exports.KpiRetailGroupType = exports.RetailMetrics = exports.GroupSizes = exports.Engagements = void 0;
var Engagements;
(function (Engagements) {
    Engagements["ALL"] = "ALL";
    Engagements["NOT_ENGAGED"] = "NOT_ENGAGED";
    Engagements["ENGAGED"] = "ENGAGED";
})(Engagements = exports.Engagements || (exports.Engagements = {}));
var GroupSizes;
(function (GroupSizes) {
    GroupSizes["ALL"] = "ALL";
    GroupSizes["EQ_1"] = "EQ_1";
    GroupSizes["GT_1"] = "GT_1";
})(GroupSizes = exports.GroupSizes || (exports.GroupSizes = {}));
var RetailMetrics;
(function (RetailMetrics) {
    // Zones
    RetailMetrics["DWELL"] = "DWELL";
    RetailMetrics["CAPTURE_RATE"] = "CAPTURE_RATE";
    RetailMetrics["POPULARITY"] = "POPULARITY";
    RetailMetrics["AFFLUENCE_IN"] = "AFFLUENCE_IN";
    RetailMetrics["AFFLUENCE_OUT"] = "AFFLUENCE_OUT";
    RetailMetrics["INSIDE"] = "INSIDE";
    RetailMetrics["GROUP_SIZE_IN"] = "GROUP_SIZE_IN";
    RetailMetrics["GROUP_SIZE_OUT"] = "GROUP_SIZE_OUT";
    RetailMetrics["N_GROUPS_IN"] = "N_GROUPS_IN";
    RetailMetrics["N_GROUPS_OUT"] = "N_GROUPS_OUT";
    // Zone With limit
    RetailMetrics["OCCUPANCY"] = "OCCUPANCY";
    RetailMetrics["AFFLUENCE_IN_QUEUE"] = "AFFLUENCE_IN_QUEUE";
    // Zone Queue
    RetailMetrics["AFFLUENCE_OUT_QUEUE"] = "AFFLUENCE_OUT_QUEUE";
    RetailMetrics["INSIDE_QUEUE"] = "INSIDE_QUEUE";
    RetailMetrics["DWELL_QUEUE"] = "DWELL_QUEUE";
    RetailMetrics["ABANDON_RATE_QUEUE"] = "ABANDON_RATE_QUEUE";
    // Air Quality
    RetailMetrics["HUMIDITY_LEVEL"] = "HUMIDITY_LEVEL";
    RetailMetrics["CO2_LEVEL"] = "CO2_LEVEL";
    RetailMetrics["TEMPERATURE"] = "TEMPERATURE";
})(RetailMetrics = exports.RetailMetrics || (exports.RetailMetrics = {}));
var KpiRetailGroupType;
(function (KpiRetailGroupType) {
    KpiRetailGroupType["DATE"] = "DATE";
    KpiRetailGroupType["TAG_CATEGORY"] = "TAG_CATEGORY";
    KpiRetailGroupType["TAG"] = "TAG";
    KpiRetailGroupType["ZONE"] = "ZONE";
    KpiRetailGroupType["ALL"] = "ALL";
    KpiRetailGroupType["GENDER"] = "GENDER";
    KpiRetailGroupType["PASSAGE"] = "PASSAGE";
    KpiRetailGroupType["ZONE_ID"] = "ZONE_ID";
    KpiRetailGroupType["ENGAGEMENT"] = "ENGAGEMENT";
    KpiRetailGroupType["GROUP_SIZE"] = "GROUP_SIZE";
})(KpiRetailGroupType = exports.KpiRetailGroupType || (exports.KpiRetailGroupType = {}));
var KpiRetailFilterType;
(function (KpiRetailFilterType) {
    KpiRetailFilterType["TAGS"] = "TAGS";
    KpiRetailFilterType["ZONES"] = "ZONES";
    KpiRetailFilterType["PASSAGES"] = "PASSAGES";
    KpiRetailFilterType["GENDERS"] = "GENDERS";
    KpiRetailFilterType["TAG_CATEGORIES"] = "TAG_CATEGORIES";
    KpiRetailFilterType["ENGAGEMENTS"] = "ENGAGEMENTS";
    KpiRetailFilterType["GROUP_SIZES"] = "GROUP_SIZES";
})(KpiRetailFilterType = exports.KpiRetailFilterType || (exports.KpiRetailFilterType = {}));
var KpiRetailQueryTarget;
(function (KpiRetailQueryTarget) {
    KpiRetailQueryTarget["ZONE"] = "zone";
    KpiRetailQueryTarget["PASSAGE"] = "passage";
})(KpiRetailQueryTarget = exports.KpiRetailQueryTarget || (exports.KpiRetailQueryTarget = {}));
/**
 * @deprecated Will be removed in the future
 */
var KpiRetailQueryTargetPassageType;
(function (KpiRetailQueryTargetPassageType) {
    KpiRetailQueryTargetPassageType["ALL"] = "all";
    KpiRetailQueryTargetPassageType["EXTERIOR"] = "exterior";
    KpiRetailQueryTargetPassageType["NON_EXTERIOR"] = "nonExterior";
})(KpiRetailQueryTargetPassageType = exports.KpiRetailQueryTargetPassageType || (exports.KpiRetailQueryTargetPassageType = {}));
